import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

export const menuExclusionRoutes = [
  '/sign-in',
  '/callback',
  '/sign-out',
  '/pending-affiliation',
  '/new-affiliation',
  '/error',
  '/invitation/',
  '/review-invitation',
  '/welcome',
  '/university-terms-and-conditions',
  '/faq',
];

const Navigation = () => {
  const location = useLocation();

  const excludedMenu = menuExclusionRoutes.some((path) =>
    location.pathname.startsWith(path)
  );

  if (excludedMenu) {
    return null;
  }

  return (
    <>
      <TopBar />
      <Sidebar />
    </>
  );
};

export default Navigation;
